import { render, staticRenderFns } from "./TutorLibs.vue?vue&type=template&id=964cdd58&scoped=true"
import script from "./TutorLibs.vue?vue&type=script&lang=js"
export * from "./TutorLibs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "964cdd58",
  null
  
)

export default component.exports